import { useTranslation } from '@/hooks/useTranslation';
import { Button } from '@/components/ui/button';

interface IProps {
  onSelect: (text: string) => void;
}

export const AISmartSuggestions = ({ onSelect }: IProps) => {
  const { t } = useTranslation();

  const suggestions: string[] = [
    t('aiChat.suggestions.revenueTrend'),
    t('aiChat.suggestions.expenseBreakdown'),
    t('aiChat.suggestions.cashFlow'),
  ];

  return (
    <div className="flex flex-wrap gap-2 justify-center px-4">
      {suggestions.map((suggestion) => (
        <Button
          key={suggestion}
          variant="outline"
          size="sm"
          className="text-xs h-7 rounded-full"
          onClick={() => onSelect(suggestion)}
        >
          {suggestion}
        </Button>
      ))}
    </div>
  );
};
